module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ed.5076865e.png";